import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=1c5d3eba&scoped=true&"
import script from "./TicketCard.vue?vue&type=script&lang=ts&"
export * from "./TicketCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d3eba",
  null
  
)

export default component.exports